import { TabContent, Tabs, TabsContents } from '@vp/visage'
import React, { FC, useMemo, useState } from 'react'
import ErrorBoundary from '../../../components/error-boundary/error-boundary.component'
import { CodeTabbedToolbar, CodeTabbedToolbarProps, CodeVisibilityState } from '../code-toolbar/code-toolbar.component'
import Sandbox from '../sandbox.component'
import CodeBlock from './code-block.component'
import styleClasses from './code-block.module.scss'
import { getLinesToHighlight, getParams } from './code-block.utility'

export const PreCodeBlock: FC<{}> = ({ children: preTag }) => {
  try {
    if (preTag && typeof preTag === 'object' && 'props' in preTag) {
      const preTagClassName = preTag?.props?.className || ''
      const [language, { title = '' }] = getParams(preTagClassName)
      const lineNumbers = getLinesToHighlight(preTag?.props.metastring || '')
      if (language) {
        if (language === 'react') {
          return <Sandbox renderReact={preTag.props.children.trim()} defaultCodeVisibilityState={CodeVisibilityState.LIMITED_HEIGHT} />
        }
        return (
          <ErrorBoundary fallback={preTag}>
            <CodeBlock
              code={preTag.props.children.trim()}
              language={language}
              title={title}
              linesToHighlight={lineNumbers}
              defaultCodeVisibilityState={CodeVisibilityState.LIMITED_HEIGHT}
            />
          </ErrorBoundary>
        )
      }
    }
  } catch (err) {
    console.error(err)
  }
  return <>{preTag}</>
}

export const CodeBlocks: FC<{ react: string; core: string; coreTitle?: string | null }> = ({ react, core, coreTitle }) => {
  const tabConfig: CodeTabbedToolbarProps['tabConfig'] = useMemo(
    () => [
      {
        key: 'react',
        title: 'React',
        language: 'jsx',
        code: react,
      },
      {
        key: 'core',
        title: coreTitle || 'Vanilla',
        language: 'markup',
        code: core,
      },
    ],
    [react, core, coreTitle],
  )
  const [activeTab, setActiveTab] = useState('react')
  return (
    <Tabs selectedTabId={activeTab} onRequestTabChange={t => setActiveTab(t || 'react')}>
      <CodeTabbedToolbar activeKey={activeTab} tabConfig={tabConfig} mt={4} />
      <TabsContents className={styleClasses.tabbedContent}>
        {tabConfig.map(config => (
          <TabContent key={config.key} tabId={config.key}>
            <CodeBlock
              code={config.code}
              language={config.language}
              disableToolbar
              defaultCodeVisibilityState={CodeVisibilityState.LIMITED_HEIGHT}
            />
          </TabContent>
        ))}
      </TabsContents>
    </Tabs>
  )
}
